<nav class="side" aria-label="Document finder navigation">
  <div class="side-h">
    <button type="button" class="icon-btn" (click)="toggle()"
      [attr.aria-label]="df.collapsed ? 'Expand navigation' : 'Collapse navigation'"
      [title]="df.collapsed ? 'Expand' : 'Collapse'">
      <df-icon name="collapse" [strokeWidth]="1.8"></df-icon>
    </button>
  </div>

  <div class="proc-card">
    <b>{{ userName }}</b>
  </div>

  <ng-container *ngFor="let g of groups; let last = last">
    <div [class.side-f]="last">
      <div class="grp" *ngIf="g.title">{{ g.title }}</div>
      <button *ngFor="let item of g.items" type="button" class="nav-i"
        [class.on]="df.view === item.view"
        [attr.aria-current]="df.view === item.view ? 'page' : null"
        [attr.data-nav]="item.view"
        [title]="item.label"
        (click)="select(item.view)">
        <df-icon [name]="item.icon"></df-icon>
        <span>{{ item.label }}</span>
        <span class="ct" *ngIf="badge(item) as n">{{ n }}</span>
      </button>
    </div>
  </ng-container>
</nav>
